import React, { useState } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { DiscountBanner } from './components/DiscountBanner';
import { ProductsSection } from './components/ProductsSection';
import { CombosSection } from './components/CombosSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ShippingSection } from './components/ShippingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FAQSection } from './components/FAQSection';
import { LocationSection } from './components/LocationSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { InstagramButton } from './components/InstagramButton';
export function App() {
  const [activeBrand, setActiveBrand] = useState<string | null>(null);
  return <div className="min-h-screen bg-dark-900 text-[#f0f0f0] font-sans overflow-x-hidden selection:bg-alphaGold selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Navbar onBrandFilter={setActiveBrand} data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <DiscountBanner data-id="element-7" />
        <ProductsSection activeBrand={activeBrand} onBrandFilter={setActiveBrand} data-id="element-8" />
        <CombosSection data-id="element-9" />
        <BenefitsSection data-id="element-10" />
        <ShippingSection data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <AboutSection data-id="element-13" />
        <FAQSection data-id="element-14" />
        <LocationSection data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
      <InstagramButton data-id="element-18" />
      <ScrollToTop data-id="element-19" />
    </div>;
}